import React from 'react';

import PropTypes from 'prop-types';
import './dialogs.scss';
import IconClose from './../../img/icons/icon_close.svg';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
// const useStyles = makeStyles((theme) => ({
//   Dialog: {
//     // display: 'flex',
//     // alignItems: 'center',
//     // justifyContent: 'center',
//     // overflow: 'scroll',
//     // position: 'absolute',
//     // top: '20%',
//     // left: '20%',
//     // height: '100%',
//     // display: 'block',
//   },
//   paper: {
//     backgroundColor: theme.palette.background.paper,
//     border: '2px solid #000',
//     boxShadow: theme.shadows[5],
//     padding: theme.spacing(2, 4, 3),
//   },
// }));

function DialogHero(props) {
  //   const classes = useStyles();
  const { onClose, selectedValue, open } = props;
  const [scroll] = React.useState('body');
  const handleClose = () => {
    onClose(selectedValue);
  };

  //   const handleListItemClick = (value) => {
  //     onClose(value);
  //   };

  return (
    <Dialog
      className="App_modal"
      onClose={handleClose}
      aria-labelledby="modal-title"
      open={open}
      scroll={'body'}
    >
      <DialogTitle id="modal-title" align="center">
        Introduction to the iTrust risk managed staking.
      </DialogTitle>
      <DialogContent dividers={scroll === 'body'}>
        <span
          className="App_close_icon"
          autoFocus
          onClick={handleClose}
          color="primary"
        >
          <img src={IconClose} alt="close modal" />
        </span>
        <p>
          iTrust.finance is a Decentralised Autonomous Organisation focused on
          alleviating current pain points in the DeFi insurance sector.
        </p>

        <p>
          We do this by focusing on 3 common cornerstones that hinder efficiency
          and growth for insurance protocols in the DeFi sector.
        </p>

        <p>
          iTrust.finance provides a win-win solution for all parties of the DAO
          and the underlying insurance protocols.
        </p>
        
      </DialogContent>
    </Dialog>
  );
}

DialogHero.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function HeroDialogContent() {
  const [open, setOpen] = React.useState(false);

  const handleClickHeroOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <DialogHero open={open} onClose={handleClose} />
      <Button className="App-button-b" onClick={handleClickHeroOpen}>
        Read More
      </Button>
    </React.Fragment>
  );
}
